/**
 * Grillion / Torvo Ecosystem Section Interactive Script
 */

(function () {
  'use strict';

  function initEcosystemSections() {
    const sections = document.querySelectorAll('.ecosystem-section');
    if (!sections.length) return;

    // IntersectionObserver for staggered entrance animation
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -60px 0px',
          threshold: 0.15,
        }
      );

      sections.forEach((sec) => {
        sec.classList.add('has-reveal');
        observer.observe(sec);
      });
    } else {
      // Fallback if IntersectionObserver is unsupported
      sections.forEach((sec) => {
        sec.classList.add('is-revealed');
      });
    }

    // Add interactive card effects
    sections.forEach((sec) => {
      const cards = sec.querySelectorAll('.ecosystem-card-hero, .ecosystem-subcard, .ecosystem-wide-card');
      cards.forEach((card) => {
        card.addEventListener('mouseenter', function () {
          this.setAttribute('data-hovered', 'true');
        });
        card.addEventListener('mouseleave', function () {
          this.removeAttribute('data-hovered');
        });
      });
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEcosystemSections);
  } else {
    initEcosystemSections();
  }

  // Shopify Theme Editor Lifecycle Hook Listeners
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.ecosystem-section')) {
      initEcosystemSections();
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelector('.ecosystem-section')) {
      const sec = event.target.querySelector('.ecosystem-section');
      sec.classList.add('is-revealed');
    }
  });
})();
